// extracted by mini-css-extract-plugin
export default {"checkIcon":"PurchaseSuccessPage_checkIcon__MaYDe","funeralDirector":"PurchaseSuccessPage_funeralDirector__6fbl7","buttonContainer":"PurchaseSuccessPage_buttonContainer__w0djF"};